import React from "react";
import TestimonialsSection from "routes/home/TestimonialsSection";
import BreadcrumbDetailed from "components/Common/BreadcrumbDetailed";
import { useSelector } from "react-redux";
import ProvideSection from "./ProvideSection";
import AddSection from "./AddSection";
import DepartmentInformation from "./DepartmentInformation";
import { useParams } from "react-router-dom";
import { useBannerAndTestimonialsData } from 'hooks/useBannerAndTestimonialsData';

const CouponDepartment = () => {
  const { departmentSlug } = useParams();

  useBannerAndTestimonialsData();

  const couponDepartmentmenu = useSelector(({ couponsDepartment }) => couponsDepartment.coupondepartmentData);

  let singleDepartmentData = couponDepartmentmenu.length > 0 ? couponDepartmentmenu.find(

    (couponDepartmentmenu) => couponDepartmentmenu.department_name_slug === departmentSlug
  ) : {};

  const breadcrumbList = [
    { lable: "Department", link: "", searchTag: "" },
    { lable: singleDepartmentData.department_name, link: "", searchTag: "" },
  ];

  return (
    <div>
      <>
        <BreadcrumbDetailed
          breadcrumbList={breadcrumbList}
          title={singleDepartmentData.department_name} //Need to pass title through api res
        />
        <DepartmentInformation singleDepartmentData={singleDepartmentData} />
        <ProvideSection />
        <AddSection />
        <TestimonialsSection />
      </>
    </div>
  );
};
export default CouponDepartment;
